import React from 'react'
import { AlertTriangle, Clock, Shield } from 'lucide-react'

interface RateLimitWarningProps {
  onRetry?: () => void
}

const RateLimitWarning: React.FC<RateLimitWarningProps> = ({ onRetry }) => {
  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
        <div className="flex items-center mb-4">
          <AlertTriangle className="w-8 h-8 text-yellow-600 mr-3" />
          <h3 className="text-lg font-semibold text-yellow-800">
            检测到访问频率限制
          </h3>
        </div>
        
        <div className="text-yellow-700 mb-6">
          <p className="mb-3">
            Cloudflare检测到我们的请求过于频繁，暂时限制了访问。这是正常的保护机制。
          </p>
          
          <div className="bg-white rounded-md p-4 mb-4">
            <h4 className="font-medium mb-2 flex items-center">
              <Shield className="w-4 h-4 mr-2" />
              已采取的优化措施：
            </h4>
            <ul className="text-sm space-y-1 ml-6">
              <li>• 图片请求延迟增加到 10-20 秒</li>
              <li>• 批量下载延迟增加到 15-30 秒</li>
              <li>• 并发数降低到单线程</li>
              <li>• 添加随机延迟避免检测</li>
            </ul>
          </div>
          
          <div className="bg-blue-50 rounded-md p-4">
            <h4 className="font-medium mb-2 flex items-center">
              <Clock className="w-4 h-4 mr-2" />
              建议操作：
            </h4>
            <ul className="text-sm space-y-1 ml-6">
              <li>• 等待 10-30 分钟后再试</li>
              <li>• 使用"样本图片"功能（已验证可用）</li>
              <li>• 避免频繁刷新页面</li>
              <li>• 批量下载时耐心等待</li>
            </ul>
          </div>
        </div>
        
        <div className="flex gap-4">
          <button
            onClick={onRetry}
            className="btn btn-primary flex items-center"
          >
            <Clock className="w-4 h-4 mr-2" />
            重试（建议等待后）
          </button>
          
          <a
            href="/sample-images"
            className="btn btn-secondary flex items-center"
          >
            <Shield className="w-4 h-4 mr-2" />
            使用样本图片
          </a>
        </div>
      </div>
    </div>
  )
}

export default RateLimitWarning 